module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAoElEQVRoQ+2ZwQ2AMAwD6eZsHgQrXCXj6vjbbc6Rkop1lX9rZu7mGt4CxgKCBEwgCP872gRMABI4ooW6BxlMMC5f8RvAC1gABIjlJoARQgMTgACx3BcZRggNjtiFfBPDLkByWwjh2yA2gQ0QkUX/IEPl/0DsMpcOwQRMABKwhSBALO8fZP4jw03ADNxGGT+uNgHOkDmYAOPH1f2DjDPIOjzS+HS/J/i6/gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/humbarger-menu.png
// module id = LYu5
// module chunks = 0